import type { IVariable } from '@carboncopyco/types';
import { ExpandableBox } from '@carboncopyco/ui';
import { VariableInput, VariablesTable } from '../DemoVariables';

export interface VariablesSectionProps {
  variables: IVariable[];
  readOnly?: boolean;
}

export function VariablesSection({
  variables,
  readOnly,
}: VariablesSectionProps) {
  return (
    <div className="flex flex-col justify-start p-2">
      <ExpandableBox
        leftArrow
        title="Variables"
        description={`Customize the values of ${variables.length} variables used in this demo.`}
      >
        <div className="max-h-ds-71 flex flex-col">
          <VariablesTable
            variables={variables}
            renderVariableInput={(variable, index) => (
              <VariableInput
                variable={variable}
                name={`variables.${index}.value`}
                readOnly={readOnly}
              />
            )}
          />
        </div>
      </ExpandableBox>
    </div>
  );
}
